<template>
    <div class="fw-billing">
        <van-nav-bar :title="title" style="background-color: #CCD5E6;" left-text="" @click-left="onClickLeft" left-arrow
                     :fixed="true">
        </van-nav-bar>
        <div class="fwb-top">
            <div class="fwbt-s">
                <div class="fwbt-item" >
                    <span class="fwbt-c1">{{deptName}}</span>
                </div>
                <div class="fwbt-item" >
                    <span class="fwbt-c1" @click="toAddMember">创建客户+</span>
                </div>
                <div class="fwbt-item">
                    <span class="fwbt-c1" @click="toMembers">选择会员</span>
                </div>
                <div class="fwbt-item" style="border-right: #EEEEEE solid 0px">
                    <span class="fwbt-c">{{serviceName}}</span>
                </div>
            </div>
            <div class="fwbt-x">
                <div class="fwbt-item1" @click="toXfs">
                    <span class="fwbt-t1" v-if="member&&member.id">{{member.memberName}}</span>
                    <span class="fwbt-t1" v-if="!member||!member.id">散客</span>
                    <span class="fwbt-b">客户名称</span>
                </div>
                <div class="fwbt-item1" v-if="mbCard&&mbCard.id" @click="toXk">
                    <span class="fwbt-t1">{{mbCard.cardName}}</span>
                    <span class="fwbt-b">{{mbCard.balance}}</span>
                </div>
                <div class="fwbt-item2"  v-if="member&&member.id" @click="toMdItems">
                    套餐
                </div>
                <div class="fwbt-item2" v-if="member&&member.id" @click="toScItems">
                    商城
                </div>
            </div>
        </div>
        <div class="fw-kdtype" ref="kdtype">
            <div class="fw-leibie">
                <span :class="{'lbActive':lbIndex==0}" class="names" @click="setType(0)">项目</span>
                <span :class="{'lbActive':lbIndex==1}" class="names" @click="setType(1)">商品</span>
                <span :class="{'lbActive':lbIndex==2}" class="names" @click="setType(2)">成品</span>
            </div>
            <Items ref="itemTab" v-if="lbIndex==0" @toItemChoose="toItemChoose" :mbCard="mbCard" :kdStyle="kdStyle" :style="kdStyle"/>
            <Skus ref="skuTab"   v-if="lbIndex==1" @toSkuChoose="toSkuChoose"   :mbCard="mbCard" :kdStyle="kdStyle" :style="kdStyle"/>
            <Specs ref="specTab" v-if="lbIndex==2" @toSpecChoose="toSpecChoose" :memberId="member.id" :kdStyle="kdStyle" :style="kdStyle"/>
        </div>
        <div class="fw-btn">
            <div class="mingxi1" @click="toMx">
                <div class="mingxi-text1">
                    <span style="font-size: 13px">明细查看</span>
                    <span style="margin-top: 5px;font-size: 20px">
                    <span style="font-size: 10px;margin-right: 5px">¥</span>{{total}}</span>
                </div>
            </div>
            <div class="baocun1" @click="saveOrder">
                {{loading==false?'保存并返回':'正在保存'}}
            </div>
            <div class="jiesuan1" >
                <span class="jiesuan-btn1" @click="toPay"> 结算</span>
            </div>
        </div>
        <van-popup v-model="mxShow" position="bottom" closeable lock-scroll overlay style="height: 100%;">
            <div style="padding: 15px;">
                <div class="fw-mx">
                    <span style="font-size: 15px">服务号: <span style="color:red;font-size: 13px">{{room.roomName}}</span></span>
                    <div class="fw-mx-nr">
                        <span style="height: 32px;font-size: 15px;line-height: 32px" v-if="member&&member.id">{{member.memberName}}</span>
                        <span style="height: 32px;font-size: 15px;line-height: 32px" v-if="!member||!member.id">散客</span>
                        <van-tabs class="kdtab" v-model="activeName">
                            <van-tab title="项目">
                                <div class="fw-mx-items">
                                    <div class="fw-mx-item" v-for="(item,index) in items">
                                        <div class="fwmxi-info">
                                            <span class="fm-name">{{item.itemName}}</span>
                                            <span class="fm-jg">¥{{item.price}}</span>
                                            <span class="fm-num">x1</span>
                                            <span class="fm-btn" @click="delData(index,1)">删除</span>
                                        </div>
                                        <span class="mxemp" v-if="fName">{{fName}}: {{item.femp.empName}} </span>
                                        <span class="mxemp" v-if="sName">{{sName}}: {{item.semp.empName}}</span>
                                        <span class="mxemp" v-if="tName">{{tName}}: {{item.temp.empName}}</span>
                                    </div>
                                </div>
                            </van-tab>
                            <van-tab title="商品">
                                <div class="fw-mx-items">
                                    <div class="fw-mx-item" v-for="(item,index) in skus">
                                        <div class="fwmxi-info">
                                            <span class="fm-name">{{item.itemName}}</span>
                                            <span class="fm-jg">¥{{item.price}}</span>
                                            <span class="fm-num">x1</span>
                                            <span class="fm-btn" @click="delData(index,2)">删除</span>
                                        </div>
                                        <span class="mxemp" v-for="emp in item.emps">{{emp.empName}} </span>
                                    </div>
                                </div>
                            </van-tab>
                            <van-tab title="成品">
                                <div class="fw-mx-items">
                                    <div class="fw-mx-item" v-for="(item,index) in specs">
                                        <div class="fwmxi-info">
                                            <span class="fm-name">{{item.itemName}} <span style="margin-left: 5px">{{item.spec}}</span></span>
                                            <span class="fm-jg">¥{{item.price}}</span>
                                            <span class="fm-num">x1</span>
                                            <span class="fm-btn" @click="delData(index,3)">删除</span>
                                        </div>
                                        <span class="mxemp" v-for="emp in item.emps">{{emp.empName}} </span>
                                    </div>
                                </div>
                            </van-tab>
                        </van-tabs>
                    </div>
                </div>
            </div>
        </van-popup>
        <van-popup v-model="mbShow" position="bottom" closeable lock-scroll overlay :close-on-click-overlay="false"
                   style="height: 100%;">
            <Memmbers ref="mbs" @setMember="setMember" @sanke="sanke" />
        </van-popup>
        <van-popup v-model="tcShow" position="bottom" closeable lock-scroll :close-on-click-overlay="false"
                   style="height: 100%;">
            <Tcs ref="tcs" :member="member" @guanbi="guanbi"/>
        </van-popup>
        <van-popup v-model="scShow" position="bottom" closeable lock-scroll :close-on-click-overlay="false" style="height: 100%;">
            <Scs ref="scs" :member="member" @guanbi="guanbi"/>
        </van-popup>
                <van-popup v-model="addShow" position="bottom" closeable lock-scroll overlay style="height: 100%;">
                    <AddMemmber ref="addmb" @gbMember="gbMember" :addType="addType" />
                </van-popup>
        <van-popup v-model="jsShow" position="bottom" lock-scroll overlay :close-on-click-overlay="false"
                   style="height: 77%;">
            <Pay v-if="jsShow" ref="pay" @gbPay="gbPay" :payItem="payItem"/>
        </van-popup>
        <van-popup v-model="xkShow" position="bottom" lock-scroll closeable overlay :close-on-click-overlay="false" style="height: 100%;overflow:hidden;">
            <Xk v-if="xkShow" ref="xk" @gbXk="gbXk"  :memberId="memberId"/>
        </van-popup>
    </div>
</template>

<script>
    import {getCookie,} from "../../utils/auth";
    import AddMemmber from "../common/addMember";
    import Memmbers from "../common/members";
    import Pay from "../common/pay";
    import Xk from "../customer/center/recharge";
    import Items from "./list/items";
    import Skus from "./list/skus";
    import Specs from "./list/specs";
    import Tcs from "./list/tcs";
    import Scs from "./list/scs";


    export default {
        components: {AddMemmber,Memmbers, Items, Skus,Specs,Tcs,Scs,Pay,Xk},
        data() {
            return {
                title: '开单选项',
                deptId: '',
                deptName: '',
                roomId: '',
                token: '',
                active: 0,
                list: [],
                gwJb: {},
                room: {},
                items: [],
                skus: [],
                specs: [],
                lbIndex: '0',

                fName: '',
                sName: '',
                tName: '',

                datas: [],
                total: 0,

                mxShow: false,
                mbShow: false,

                member: {},
                mbCard: {},

                memberId:'',
                cardId:'',
                serviceNo:'',
                serviceName:'',

                tcShow: false,
                scShow: false,

                addType:'kd',
                addShow: false,
                activeName:0,

                loading:false,
                jsShow: false,
                payItem:{},

                xkShow:false,
                kdStyle:'',
            };
        },
        async mounted() {
            document.title = "数字智慧助手"
            let kdtype=this.$refs.kdtype
            this.kdStyle='height:'+(kdtype.offsetHeight-85)+'px'
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.deptName = this.fwUser.deptName
            this.token = this.fwUser.token
            if(this.$route.query.roomId){
                this.roomId =this.$route.query.roomId
            }
            if(this.$route.query.fwh){
                this.serviceNo = this.$route.query.fwh
                this.serviceName=this.$route.query.fwh
            }
            if(this.$route.query.memberId){
                this.memberId = this.$route.query.memberId
            }
            if(this.$route.query.cardId){
                this.cardId = this.$route.query.cardId
            }
            if (this.roomId){
                this.getFwRoomNo()
            }
            if (this.memberId){
                await this.getMember()
            }
            this.initMbCard(this.mbCard)
            this.getFwEmps()
        },
        methods: {
            toXk(){
                if (this.mbCard&&this.mbCard.id){
                    this.memberId=this.member.id
                    this.xkShow=true
                }
            },
            gbXk(){
               this.getMember()
                this.xkShow=false
            },
            toAddMember(){
                this.addShow=true
                if (this.$refs.addmb){
                    this.$refs.addmb.chushi();
                }
            },
            gbMember(member){
                this.member=member
                this.addShow=false
            },

            toMembers(){
                this.mbShow = true
                if (this.$refs.mbs){
                    this.$refs.mbs.chushi();
                }
            },
            toMdItems(){
                if (!this.member.id) {
                    return;
                }
                this.tcShow=true
            },
            toScItems(){
                if (!this.member.id) {
                    return;
                }
                this.scShow=true
            },
            setType(lbIndex) {
                this.lbIndex = lbIndex
            },

            sanke() {
                this.member = {}
                this.mbCard = {}
                this.mbShow = false
                this.sankejiage()
            },

            setMember(data) {
                this.member = data.mb
                if (data.card&&data.card.id){
                    this.mbCard = data.card
                    this.cardId=data.card.id
                    this.huiyuanjiage()
                }
                this.mbShow = false
            },
            delData(index,type) {
                if (type==1){
                    let item = this.items[index];
                    this.items.splice(index, 1)
                    var to = parseFloat(this.total) - parseFloat(item.price);
                    this.total = to.toFixed(1)
                }
                if (type==2){
                    let item = this.skus[index];
                    this.skus.splice(index, 1)
                    var to = parseFloat(this.total) - parseFloat(item.price);
                    this.total = to.toFixed(1)
                }
                if (type==3){
                    let item = this.specs[index];
                    this.specs.splice(index, 1)
                    var to = parseFloat(this.total) - parseFloat(item.price);
                    this.total = to.toFixed(1)
                }
            },

            toMx() {
                if (this.items.length > 0||this.skus.length>0||this.specs.length>0) {
                    this.mxShow = true
                } else {
                    this.$notify("没添加任何商品!");
                }
            },
            async getFwEmps() {
                let data = {
                    deptId: this.deptId,
                    token: this.token,
                }
                let res = await this.$get("/fw/getFwEmps", data)
                this.fName = res.fName;
                this.sName = res.sName;
                this.tName = res.tName;
            },
            async getFwRoomNo() {
                let data = {
                    roomId: this.roomId,
                }
                let res = await this.$get("/fw/getFwRoomNo", data)
                if (res.room){
                    this.serviceNo=res.room.roomNo
                    this.serviceName=res.room.roomName
                }
            },
            //获取会员信息
            async getMember() {
                let res = await this.$get("/sw/getSwMbmber", {memberId: this.memberId, mcId: this.cardId});
                this.member = res.member
                if (res.member) {
                    this.orderSex = res.member.sex
                    if (res.member.sex == 0) {
                        this.orderSex = 1
                    }
                }
                if (res.memberCard) {
                    this.mbCard = res.memberCard
                }
            },

            async saveOrder() {
                if (this.loading){
                    return ;
                }
                this.loading = true
                let mcId = ''
                if (this.mbCard && this.mbCard.id) {
                    mcId = this.mbCard.id
                }
                let memberId = ''
                let orderSex = 1
                if (this.member && this.member.id) {
                    memberId = this.member.id
                    orderSex = this.member.sex
                }
                var data = {
                    itemStr: JSON.stringify(this.items),
                    skuStr: JSON.stringify(this.skus),
                    specStr: JSON.stringify(this.specs),
                    total: this.total,
                    memberId: memberId,
                    mcId: mcId,
                    orderSex: orderSex,
                    token: this.token,
                    deptId: this.deptId,
                    serviceNo: this.serviceNo
                }
                let res = await this.$post("/sw/saveBillingOrder", data);
                if (res.code == 200) {
                    this.$router.push('/home')
                    // this.loading = false
                    // this.$router.go(-1)
                    // this.$message.success(res.message);
                } else {
                    this.loading=false
                    this.$message.error(res.message);
                }
            },

            toPay(){
                if (this.items.length > 0 || this.skus.length > 0 || this.specs.length > 0) {
                    let mcId = ''
                    if (this.mbCard && this.mbCard.id) {
                        mcId = this.mbCard.id
                    }
                    let memberId = ''
                    let orderSex = 1
                    if (this.member && this.member.id) {
                        memberId = this.member.id
                        orderSex = this.member.sex
                    }
                    var data = {
                        itemStr: JSON.stringify(this.items),
                        skuStr: JSON.stringify(this.skus),
                        specStr: JSON.stringify(this.specs),
                        total: this.total,
                        memberId: memberId,
                        mcId: mcId,
                        orderSex: orderSex,
                        token: this.token,
                        deptId: this.deptId,
                        serviceNo: this.serviceNo,
                    }
                    this.data=data
                    this.payItem={
                        orderType:'kd',
                        data:data,
                        totalStr:this.total.toString(),
                    }
                    if(this.member&&this.member.id){
                        this.payItem.member=this.member
                    }
                    if(this.cardId){
                        this.payItem.cardId=this.cardId
                    }
                    this.jsShow=true
                } else {
                    this.$notify("没添加任何商品!");
                    return;
                }
            },
            gbPay(){
                this.jsShow = false
            },

            toItemChoose(data) {
                this.items.push(data.item)
                this.total = parseFloat(this.total) + parseFloat(data.total)

            },

            toSkuChoose(data) {
                this.skus.push(data.item)
                this.total = parseFloat(this.total) + parseFloat(data.total)
            },
            toSpecChoose(data) {
                this.specs.push(data.item)
                this.total = parseFloat(this.total) + parseFloat(data.total)
            },

            guanbi(item) {
                this.items.push(item)
                this.tcShow = false
                this.scShow = false
            },

            initMbCard(mc){
                if (this.$refs.itemTab){
                    this.$refs.itemTab.qiehuan(mc);
                }
                if (this.$refs.skuTab){
                    this.$refs.skuTab.qiehuan(mc);
                }
            },
            sankejiage(){
                this.initMbCard()
                //切换到散客
                var total = 0;
                this.items.forEach(item => {
                    this.setItemPrice('SK',item)
                })
                this.skus.forEach(item => {
                    this.setSkuPrice('SK',item)
                })
                this.hjTotal()
            },

            huiyuanjiage(){
                this.initMbCard(this.mbCard)
                //切换到会员卡
                this.items.forEach(item => {
                    this.setItemPrice('HY',item,this.mbCard)
                })
                this.skus.forEach(item => {
                    this.setSkuPrice('HY',item,this.mbCard)
                })
              this.hjTotal()
            },
            //切换散客/会员卡计算价格 项目
            setItemPrice(type,item,mc) {
                //散客价格
                if (type=='SK'){
                    item.price=item.oglPrice
                }
                //会员价
                if (type=='HY'){
                    if (item.discount == 1) {
                            let vips=false
                            if (item.itemVips.length > 0) {
                                item.itemVips.forEach(vip => {
                                    if (vip.cardId == mc.cardId) {
                                        item.price = vip.vipPrice;
                                        vips=true
                                    }
                                })
                            }
                            if (!vips){
                                if (mc.itemDiscount > 0) {
                                    item.price = this.calculationPrice(item.price, mc.itemDiscount)
                                }
                            }
                    }
                }
            },

            //切换散客/会员卡计算价格 卖品
            setSkuPrice(type,item,mc) {
                //散客价格
                if (type=='SK'){
                    item.price=item.oglPrice
                }
                //会员价
                if (type=='HY'){
                    if (mc.skuDiscount > 0) {
                        item.price = this.calculationPrice(item.price, this.mc.skuDiscount)
                    }
                }
            },
             hjTotal(){
                let itemTotal=0
                let skuTotal=0
                let specTotal=0
                this.items.forEach(item=>{
                    itemTotal=parseFloat(itemTotal) + parseFloat(item.price)
                })
                 this.skus.forEach(item=>{
                     skuTotal=parseFloat(skuTotal) + parseFloat(item.price)
                 })
                 this.specs.forEach(item=>{
                     itemTotal=parseFloat(specTotal) + parseFloat(item.price)
                 })
                 let total=parseFloat(itemTotal) + parseFloat(skuTotal) + parseFloat(specTotal)
                 this.total=total.toFixed(1)
             },

            //计算价格
            calculationPrice(num1, num2) {
                var num = parseFloat(num1 * num2 / 10)
                return num.toFixed(1);
            },
            toXfs(){
                if (this.member&&this.member.id){
                    this.$router.push('/fwMdCmp?memberId='+this.member.id)
                }
            },
            onClickLeft() {
                this.$router.go(-1)
            },
        },
    };
</script>

<style lang="scss" scoped>
    ::v-deep .el-input .el-input__inner {
        border-color: #ffffff;
        border-radius: 0px;
        border-bottom-color: #EEEEEE;
    }

    .kdtab /deep/ .van-tabs--line {
        height: 32px;
    }

    .kdtab /deep/ .van-tabs__wrap {
        height: 32px;
    }
</style>
